import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import LoaderComponent from '../components/Loader'
import LoaderButtonComponent from '../components/LoaderButton'

const NAMESPACE = 'Core'
export const LOADING = NAMESPACE + '/Loading'
export const LOADING_DELAYED = NAMESPACE + '/LoadingDelayed'
export const LOADING_FAILED = NAMESPACE + '/LoadingFailed'

export const STATUS_LOADING = 'Loading'
export const STATUS_LOADING_DELAYED = 'LoadingDelayed'
export const STATUS_LOADING_FAILED = 'LoadingFailed'
export const STATUS_LOADED = 'Loaded'

// reducer

var loadingReducerLock = false

export function loadingReducer(state = null, action) {
    switch (action.type) {
        case LOADING:
            if (!loadingReducerLock) {
                // action is not consecutive 
                if (state && Object.keys(state).reduce((r, n) => r || state[n] == STATUS_LOADING_FAILED || state[n] == STATUS_LOADED, false)) {
                    // all previous consecutive actions completed
                    state = null
                }
            }
            return {...state, [action.name]: STATUS_LOADING}
        case LOADING_DELAYED:
            return {...state, [action.name]: STATUS_LOADING_DELAYED}
        case LOADING_FAILED:
            loadingReducerLock = true
            setTimeout(() => loadingReducerLock = false, 0)
            return {...state, [action.name]: STATUS_LOADING_FAILED}
        default:
            if (state && state[action.type] != undefined) {
                loadingReducerLock = true
                setTimeout(() => loadingReducerLock = false, 0)
                return {...state, [action.type]: STATUS_LOADED}
            }
            return state
    }
}

// middleware

export function loadingMiddleware({dispatch}) {
    return (next) => (action) => {
        if (action.loader) {

            dispatch({
                type: LOADING,
                name: action.name
            })

            var timer = setTimeout(() => {
                dispatch({
                    type: LOADING_DELAYED,
                    name: action.name
                })
            }, action.delay)

            return Promise.resolve(next(action.loader)).then((action) => {
                clearTimeout(timer)
                return action
            }).catch((error) => {
                clearTimeout(timer)

                dispatch({
                    type: LOADING_FAILED,
                    name: action.name
                })
                console.error(error)

                return Promise.reject(error)
            })
        }
        return next(action)
    }
}


// higher order component

export function connectLoading(option = {}) {
    return (WrappedComponent) => {

        class LoadingConnector extends Component {

            constructor(props) {
                super(props)

                this.state = {}
            }

            componentWillMount() {
                const {loading} = this.props

                var actionLoadingDelayed =  isLoadingDelayed(loading, option.include, option.exclude)
                this.setState({actionLoadingDelayed})
            }

            componentWillReceiveProps(nextProps) {
                if (nextProps.loading != this.props.loading) {
                    const {loading} = nextProps
                    const {actionLoadingDelayed} = this.state

                    clearTimeout(this._timer)
                    this._timer = setTimeout(() => {
                        // wait for consecutive actions
                        var nextActionLoadingDelayed = actionLoadingDelayed && isLoading(loading, option.include, option.exclude) || isLoadingDelayed(loading, option.action)
                        this.setState({actionLoadingDelayed: nextActionLoadingDelayed})
                    }, 0)
                }
            }

            componentWillUnmount() {
                clearTimeout(this._timer)
            }

            render() {
                const {actionLoadingDelayed} = this.state

                if (actionLoadingDelayed) {
                    return (
                        <LoaderComponent />
                    )
                }
                return <WrappedComponent {...this.props} />
            }
        }

        return LoadingConnector
    }
}

export function connectLoadingLock(option = {}) {
    return (WrappedComponent) => {

        class LoadingLockConnector extends Component {

            constructor(props) {
                super(props)

                this.state = {
                    actionLoading: false
                }
            }

            componentWillReceiveProps(nextProps) {
                if (nextProps.loading != this.props.loading) {
                    const {loading} = nextProps

                    clearTimeout(this._timer)
                    this._timer = setTimeout(() => {
                        // wait for consecutive actions
                        const actionLoading = isLoading(loading, option.include, option.exclude)
                        this.setState({actionLoading})
                    }, 0)
                }
            }

            componentWillUnmount() {
                clearTimeout(this._timer)
            }

            shouldComponentUpdate(nextProps, nextState) {
                return !nextState.actionLoading
            }

            render() {
                return <WrappedComponent {...this.props} />
            }
        }

        return LoadingLockConnector
    }
}

// component

class Loader extends Component {
    static propTypes = {
        include: PropTypes.any,
        exclude: PropTypes.any
    }

    constructor(props) {
        super(props)

        this.state = {}
    }

    componentWillMount() {
        const {loading, include, exclude} = this.props

        var actionLoadingDelayed =  isLoadingDelayed(loading, include, exclude)
        this.setState({actionLoadingDelayed})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.loading != this.props.loading) {
            const {loading, include, exclude} = nextProps
            const {actionLoadingDelayed} = this.state

            clearTimeout(this._timer)
            this._timer = setTimeout(() => {
                // wait for consecutive actions
                var nextActionLoadingDelayed = actionLoadingDelayed && isLoading(loading, include, exclude) || isLoadingDelayed(loading, include, exclude)
                this.setState({actionLoadingDelayed: nextActionLoadingDelayed})
            }, 0)
        }
    }

    componentWillUnmount() {
        clearTimeout(this._timer)
    }

    render() {
        const {children} = this.props
        const {actionLoadingDelayed} = this.state

        if (actionLoadingDelayed) {
            return (
                <LoaderComponent />
            )
        }

        return (
            <div>{children}</div>
        )
    }
}

Loader = connect((state) => ({
    loading: state.loading
}))(Loader)

export {Loader}

class LoaderButton extends Component {
    static propTypes = {
        action: PropTypes.any
    }

    constructor(props) {
        super(props)

        this.state = {}
    }

    componentWillMount() {
        const {loading, action} = this.props

        var actionLoading = isLoading(loading, action)
        this.setState({actionLoading})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.loading != this.props.loading) {
            const {loading, action} = nextProps
            const {actionLoading} = this.state

            clearTimeout(this._timer)
            this._timer = setTimeout(() => {
                // wait for consecutive actions
                var nextActionLoading = isLoading(loading, action)
                this.setState({actionLoading: nextActionLoading})
            }, 0)
        }
    }

    componentWillUnmount() {
        clearTimeout(this._timer)
    }

    render() {
        const {loading, onClick, ...others} = this.props
        const {actionLoading} = this.state

        return (
            <LoaderButtonComponent
               loading={actionLoading}
               onClick={(e) => {onClick(e)}}
               {...others} />
        )
    }
}

LoaderButton = connect((state) => ({
    loading: state.loading
}))(LoaderButton)

export {LoaderButton}

class LoaderForm extends Component {
    static propTypes = {
        loading: PropTypes.object.isRequired,
        action: PropTypes.any
    }

    constructor(props) {
        super(props)

        this.state = {}
    }

    componentWillMount() {
        const {loading, action} = this.props

        var actionLoading = isLoading(loading, action)
        this.setState({actionLoading})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.loading != this.props.loading) {
            const {loading, action} = nextProps
            const {actionLoading} = this.state

            clearTimeout(this._timer)
            this._timer = setTimeout(() => {
                // wait for consecutive actions
                var nextActionLoading = isLoading(loading, action)
                this.setState({actionLoading: nextActionLoading})
            }, 0)
        }
    }

    componentWillUnmount() {
        clearTimeout(this._timer)
    }

    _enhance(children) {
        return React.Children.map(children, (child) => {
            if (child && child.type && (child.type.displayName == 'Button' || child.type.displayName == 'Input')) {
                return React.cloneElement(child, {
                    disabled: true
                })
            }
            if (child && child.props) {
                const {children} = child.props

                return children && React.cloneElement(child, {
                    children: this._enhance(children)
                }) || child
            }
            return child
        })
    }

    render() {
        const {children, loading, action, others} = this.props
        const {actionLoading} = this.state

        return (
            <form
                {...others}>
                {actionLoading && this._enhance(children) || children}
            </form>
        )
    }
}

export {LoaderForm}

// helpers

function match(value, regexes) {
    regexes = (regexes instanceof Array) && regexes || [regexes]
    return regexes.find((r) => value.match(r)) && true || false
}

export function isLoading(loading, include, exclude) {
    var result = loading && true || false
    result = result && Object.keys(loading).find((n) => loading[n] == STATUS_LOADING || loading[n] == STATUS_LOADING_DELAYED) && true || false
    result = result && (!include || Object.keys(loading).find((n) => match(n, include))) && true || false
    result = result && (!exclude || !Object.keys(loading).find((n) => match(n, exclude))) && true || false
    return result
}

export function isLoadingDelayed(loading, include, exclude) {
    var result = loading && true || false
    result = result && Object.keys(loading).find((n) => loading[n] == STATUS_LOADING_DELAYED) && true || false
    result = result && (!include || Object.keys(loading).find((n) => match(n, include))) && true || false
    result = result && (!exclude || !Object.keys(loading).find((n) => match(n, exclude))) && true || false
    return result
}

// action

export default function loading(loader, name, delay = 700) {
    return {loader, name, delay}
}



// WEBPACK FOOTER //
// ./lib/core/redux/loading.js